/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<41363a31ff79b647ded426f9ec96642f>>
 * @relayHash ef938e67c2633482f20211c0d90f178a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8b9c7cdfbfaa4202021e7d75ea8d977c47b402c709533133c406057828ff4ed8

import type { ConcreteRequest, Query } from 'relay-runtime';
export type helpReportingPageQuery$variables = {
  cloudId: string;
  helpCenterAri: string;
};
export type helpReportingPageQuery$data = {
  readonly helpCenter: {
    readonly helpCenterReportingById: {
      readonly __typename: "HelpCenterReporting";
      readonly contentGapIndicatorsWithMetaData: {
        readonly contentGapIndicators: ReadonlyArray<{
          readonly clusterId: string;
          readonly coverage: number;
          readonly keywords: string;
          readonly questionsCount: number;
        }> | null | undefined;
      } | null | undefined;
      readonly performanceIndicatorsWithMetaData: {
        readonly performanceIndicators: ReadonlyArray<{
          readonly currentValue: string;
          readonly name: string;
          readonly previousValue: string | null | undefined;
          readonly timeWindow: string | null | undefined;
        }> | null | undefined;
      } | null | undefined;
    } | {
      readonly __typename: "QueryError";
      readonly message: string | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
};
export type helpReportingPageQuery = {
  response: helpReportingPageQuery$data;
  variables: helpReportingPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "HelpCenterQueryApi",
    "kind": "LinkedField",
    "name": "helpCenter",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
          }
        ],
        "concreteType": null,
        "kind": "LinkedField",
        "name": "helpCenterReportingById",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "HelpCenterReportingPerformanceIndicatorsWithMetaData",
                "kind": "LinkedField",
                "name": "performanceIndicatorsWithMetaData",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HelpCenterReportingPerformanceIndicator",
                    "kind": "LinkedField",
                    "name": "performanceIndicators",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "currentValue",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "previousValue",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "timeWindow",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "HelpCenterContentGapIndicatorsWithMetaData",
                "kind": "LinkedField",
                "name": "contentGapIndicatorsWithMetaData",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HelpCenterContentGapIndicator",
                    "kind": "LinkedField",
                    "name": "contentGapIndicators",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "clusterId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "coverage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "keywords",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "questionsCount",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "HelpCenterReporting",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "type": "QueryError",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "helpReportingPageQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "helpReportingPageQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "8b9c7cdfbfaa4202021e7d75ea8d977c47b402c709533133c406057828ff4ed8",
    "metadata": {},
    "name": "helpReportingPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "096d458141224ceb9c7e3b2ad5f60f5d";

export default node;
